export default __webpack_public_path__ + "assets/left-arrow.2f428fa4.svg";